export default __webpack_public_path__ + "static/media/nasdaq-icon.92d7cde2.svg";